<template>
  <div>
    <button id="api" v-on:click="api" class="btn btn-default">Call API</button>
    <pre id="results" style="text-align: left"></pre>
  </div>
</template>

<script>
// import userManager from '@/modules/auth/user-manager'
import runtimeConfig from "@/common/runtime-config";

export default {
  name: "DbgApiTest",
  props: {
    msg: String,
  },
  data() {
    return {};
  },
  mounted() {
    const vm = this;
    const user = this.$store.state.auth.oidc.user;
    if (user) {
      vm.log("User logged in", user.profile);
    } else {
      vm.log("User not logged in");
    }
    console.log(process.env);
  },
  methods: {
    log() {
      document.getElementById("results").innerText = "";

      Array.prototype.forEach.call(arguments, function (msg) {
        if (msg instanceof Error) {
          msg = "Error: " + msg.message;
        } else if (typeof msg !== "string") {
          msg = JSON.stringify(msg, null, 2);
        }
        document.getElementById("results").innerHTML += msg + "\r\n";
      });
    },
    api() {
      const vm = this;
      const user = this.$store.state.auth.oidc.user;
      var url = runtimeConfig.apiBaseUrl + "/api/dbg/currentuser";
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.onload = function () {
        const json = xhr.responseText ? JSON.parse(xhr.responseText) : "";
        vm.log(xhr.status, json);
      };
      if (user) {
        xhr.setRequestHeader("Authorization", "Bearer " + user.access_token);
      }
      xhr.send();
    },
  },
};
</script>